<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <v-toolbar flat color="white">
          <v-toolbar-title>Environments dfjsfxffhxx</v-toolbar-title>
          <v-spacer></v-spacer>
              <v-btn @click="()=>{dialog=!dialog;editedIndex=-1}" color="primary">
                <v-icon left>mdi-plus</v-icon> New environment
              </v-btn>
          <v-dialog v-model="dialog" max-width="70%">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="newEnvironmentForm">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 class="text-xs-center">
                        <v-text-field
                          :rules="[o=>!!o || 'The name is required',o=> /^[a-zA-Z0-9-_]+$/.test(o)||'Special characters are not allowed']"
                          v-model="editedItem.name"
                          label="Environment title"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12> <h3>Variables</h3></v-flex>
                      <v-flex xs12>
                        <v-data-table
                          hide-default-footer
                          :headers="[{ text: 'Name', align: 'left', sortable: false, value: 'name' }, { text: 'Value',sortable: false, name:'value'},{ text: 'Action',sortable:false, name:''}]"
                          :items="editedItem.variables"
                          class="elevation-1"
                        >
                          <template v-slot:item="{item, index}">
                              <tr>
                            <td>
                              <v-text-field :rules="(index == (editedItem.variables.length-1) && item.value.trim()=='' )?[] : [o=>!!o || 'The name is required',o=> /^[a-zA-Z0-9-_]+$/.test(o)||'Special characters are not allowed']" @keyup="handleVarInputkeyup(item, index)" v-model="item.name" label="Name"></v-text-field>
                            </td>
                            <td>
                              <v-text-field
                                @keyup="handleVarInputkeyup(item, index)"
                                v-model="item.value"
                                label="Value"
                              ></v-text-field>
                            </td>
                            <td class="justify-center layout px-0">
                              <v-btn icon @click="()=>{editedItem.variables=editedItem.variables.filter(e=>{return e.name !== item.name});}">
                                <v-icon small> mdi-delete </v-icon>
                                </v-btn>
                            </td>
                              </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                      <v-flex xs12 class="text-xs-center">
                        <v-btn color="primary" @click="editedItem.variables.push(emptyVariable())">
                          <v-icon left>mdi-plus</v-icon> Append variable
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close">Cancel</v-btn>
                <v-btn @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="envs" class="elevation-1">
          <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.updated_at}}</td>
                <td class="justify-center layout px-0">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                </td>
              </tr>

          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import FunctionService from './services/FunctionService'

  export default ({
    data() {
      return {
        dialog: false,
        headers: [{
            text: 'Environment title',
            align: 'left',
            sortable: false,
            value: 'name'
          },{
            text: 'Updated at',
            sortable: false,
            value: 'updated_at'
          },
          {
            text: 'Actions',
            name: '',
            sortable: false
          }
        ],
        envs: [],
        editedIndex: -1,
        editedItem: {
          name: '',
          variables: [{
                name: '',
                value: '',
              }]
        },
        defaultItem: {
          name: '',
          variables: [{
                name: '',
                value: '',
              }]
        }
      }
    },
    props:[],
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New environment' : 'Edit environment'
      }
    },

    watch: {
      dialog(val) {
        val || this.close()
      }
    },

    created() {
      this.initialize()
    },

    methods: {
      varsToArray(vars){
        let temp_vars = []
        for(var name in vars)
          temp_vars.push({name:name,value:vars[name]})
        return temp_vars
      },
      varsToObject(vars){
        let temp_vars = {}
        vars.map((o)=>{
          temp_vars[o.name||'']=o.value||''
          })
        return temp_vars
      },
      emptyVariable(){
        return {
          name:'',
          value:'',
        }
      },
      handleVarInputkeyup(item, index){
        let v = item
        if((v.name.trim()+v.value.trim())!='' && (index+1) == this.editedItem.variables.length)
            this.editedItem.variables.push(this.emptyVariable())
      },
      initialize() {
        FunctionService.getEnvironments().then(r=>{
          this.envs = r.data.results
            console.log('envs')
            console.log(this.envs)
        }).catch(err=>{
          this.$store.commit('push', {msg: 'Error while getting environments (' + err +')', color: 'error'})
        })
      },
      editItem(item) {
        FunctionService.getEnvironment(item.id).then(r=>{
          let temp = _.cloneDeep(item)
          this.editedIndex = this.envs.findIndex(o=>{return o.name==item.name})
          temp.variables= this.varsToArray(r.data.variables).concat([this.emptyVariable()])
          this.editedItem = temp
          this.dialog = true
        }).catch(err=>{
          this.$store.commit('push', {msg: 'Error while getting environments (' + err +')', color: 'error'})
        })
      },
      deleteItem(item) {
        if(confirm('Are you sure you want to delete this environment ?')){
          FunctionService.deleteEnvironment(item).then((r)=>{
            this.$store.commit('push', {msg: 'Deleted environment with success !', color: 'success'});
            const index = this.envs.indexOf(item)
            this.envs.splice(index, 1)
            this.$emit('updateFunctionEnvs',this.envs.map(o=>{return o.name}))
          }).catch((err) => {
              this.$store.commit('push', {msg: 'Error while deleting environment (' + err +')', color: 'error'})
          })
        }
      },
      close() {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save() {
        if(!this.$refs.newEnvironmentForm.validate())
          return;
        let temp_env = Object.assign({}, this.editedItem);
        temp_env.variables = this.varsToObject(this.editedItem.variables.filter(e=>{return (e.name.trim()+e.value.trim())!=''}))
        if (this.editedIndex > -1) {
          // Update
          if(_.isEqual(this.envs[this.editedIndex], this.editedItem)){
            this.$store.commit('push', {msg: 'No informations has been updated to save', color: 'success'});
            return
          }

          FunctionService.updateEnvironment(this.envs[this.editedIndex].id,temp_env).then(r=>{
            this.envs[this.editedIndex] = Object.assign({}, temp_env)
            this.$emit('updateFunctionEnvs',this.envs.map(o=>{return o.name}))
            this.$store.commit('push', {msg: 'Updated environment with success !', color: 'success'});
          }).catch(err=>{
            this.$store.commit('push', {msg: 'Error while updating environment (' + err +')', color: 'error'})
          })
        } else {
          // Create
          FunctionService.createEnvironment(temp_env).then(r=>{
            r.data.variables = this.varsToArray(r.data.variables)
            this.envs.push(r.data)
            this.$emit('updateFunctionEnvs',this.envs.map(o=>{return o.name}))
            this.$store.commit('push', {msg: 'Created environment with success !', color: 'success'});
            this.editItem = this.defaultItem;
          }).catch(err=>{
            this.$store.commit('push', {msg: 'Error while creating new environment (' + err +')', color: 'error'})
          })
        }
        this.close()
      }
    }
  })
</script>
